import { API_URL } from "../Config/config";
import { fetchApiData } from "../Helper/helper";

export const getClientToken = async () => {
	let response = await fetchApiData(`${API_URL}/common/freight-rates?limit=1`, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
		},
	});

	if (response && !response.error) {
		return response.data;
	} else {
		response.error;
	}
};

/**
 * 
 * @param {{"amount1": string, "amount2": string, "funding_id": string}} reqObj
 * @param {string} amount1 Micro deposit amount
 * @param {string} amount2 Micro deposit amount
 * @param {string} funding_id Dwolla funding id of the funding method
 */
export const dwollaVerifyFundingSource = async (reqObj) => {
	const response = await fetchApiData(`${API_URL}/dwolla/verify/micro/deposits`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(reqObj),
	});

	return response;

}



export const dwollaGetFundingSource = async () => {
	const response = await fetchApiData(`${API_URL}/dwolla/get-funding-source-list`, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
		},
	})
	return response;
}



export const postDwollaUploadBeneficialUserDocuments = async (formData) => {

	const response = await fetchApiData(`${API_URL}/dwolla/upload-beneficial-user-documents`, {
		method: "POST",
		headers: {
			"Content-Type": "multipart/form-data",
			"accept": "application/json"
		},
		body: formData,
	});
	return response;

};
export const postDwollaUploadDocuments = async (formData) => {
	const response = await fetchApiData(`${API_URL}/dwolla/upload-documents`, {
		method: "POST",
		headers: {
			"Content-Type": "multipart/form-data",
			"accept": "application/json"
		},
		body: formData,
	});
	return response;

};

/**
 * 
 * @returns 
 */
export const getDwollaOnDemandAuth = async () => {
	const response = await fetchApiData(`${API_URL}/dwolla/get-on-demand-authorizations`, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
		},
	});
	return response;
}

/**
 * 
 * @param {{"customerId": string, "fundingSourceName": string, "plaidToken": string,  "plaidToken": "", "_links": {}}} reqObj 
 * @returns funding source list from plaid
 */
export const postDwollaPlaidCreateFundingSource = async (reqObj) => {
	const response = await fetchApiData(`${API_URL}/dwolla/create-funding-source-plaid`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(reqObj),
	});
	return response;
}

/**
 * 
 * @returns Dwolla Plaid Token
 */
export const getDwollaPlaidCreateToken = async () => {
	const response = await fetchApiData(`${API_URL}/dwolla/plaid-create-token`, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
		},
	});
	return response;

}

/**
 * 
 * @param {{  "accountId": string,"publicToken": string}} reqObj 
 * @returns Dwolla plaid Exchange Token
 */
export const postDwollaPlaidExchangeToken = async (reqObj) => {
	const response = await fetchApiData(`${API_URL}/dwolla/plaid-micro-deposit-status`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(reqObj),
	});
	return response;
}
/**
 * 
 * @param {{  "accountId": string,"publicToken": string}} reqObj 
 * @returns Dwolla plaid Exchange Token
 */
export const postNewDwollaPlaidTokenForManual = async (reqObj) => {
	const response = await fetchApiData(`${API_URL}/dwolla/plaid-create-token-new`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(reqObj),
	});
	return response;
}
// /**
//  * 
//  * @param {{  "accountId": string,"publicToken": string}} reqObj 
//  * @returns Dwolla plaid Exchange Token
//  */
// export const postDwollaPlaidExchangeToken = async (reqObj) => {
// 	const response = await fetchApiData(`${API_URL}/dwolla/plaid-exchange-token`, {
// 		method: "POST",
// 		headers: {
// 			"Content-Type": "application/json",
// 		},
// 		body: JSON.stringify(reqObj),
// 	});
// 	return response;
// }


/**
 * 
 * @returns dwolla user info
 */
export const getDwollaUserInfo = async () => {
	const response = await fetchApiData(`${API_URL}/dwolla/get-dwolla-user-info`, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
		},
	})

	return response;
}
/**
 * 
 * @returns dwolla user info
 */
export const postCreateProcessorToken = async (reqObj) => {
	const response = await fetchApiData(`${API_URL}/dwolla/plaid-create-processor`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(reqObj),
	})

	return response;
}



export function displayFormData(formData) {
	for (const entry of formData.entries()) {
		// console.log(entry[0], entry[1]);
	}
}



export function postFrightRateDocument(formData) {
	const response = fetchApiData(`${API_URL}/seller/freightrateFile`, {
		method: "POST",
		headers: {
			"Content-Type": "multipart/form-data",
		},
		body: formData,
	})

	return response;
}


export function postUnverifiedAccountDetailsFromAccessToken(accessToken) {
	const response = fetchApiData(`${API_URL}/dwolla/get-unverified-accounts`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			"access_token": accessToken
		}),
	})

	return response;
}


export async function postCreateFundingSource(data) {
	const response = await fetchApiData(`${API_URL}/dwolla/create-funding-source`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(data),
	});

	return response;
}
